import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { File, FileEntry, DirectoryEntry } from '@ionic-native/file';
import { Asset } from '../../interfaces/asset.model';
import { Zip } from '@ionic-native/zip';
import { AssetFile } from '../../interfaces/asset-file.model';
import { Platform } from 'ionic-angular';
import { ENV } from '@app/env';
import { HelperProvider } from '../../providers/helper/helper';

@Injectable()
export class FileProvider {

  win: any = window;
  thumbWebURL: string = ENV.wsUrl + "STSService/Thumbnails/"
  assetWebURL: string = ENV.wsUrl + "STSService/Assets/"
  isIosPlatform: boolean;
  maxFileSize: number = 20; // file size in MB


  constructor(public http: HttpClient, public file: File, private zip: Zip, public plt: Platform, public helperService: HelperProvider) {
    // this.isIosPlatform = this.plt.is('ios');
    //[VP - 27/01/2021] Use custom function to detect iOS because of ionic bug: https://github.com/ionic-team/ionic-v3/issues/1104
    this.isIosPlatform = this.helperService.isIOS();
  }

  createDirectory(fileType: string): Promise<DirectoryEntry>{
    return this.file.createDir(this.file.documentsDirectory, fileType, false);
  }

  checkDirectory(fileType: string): Promise<boolean>{
    return this.file.checkDir(this.file.documentsDirectory, fileType);
  }

  removeDirectory(assetName: string){
    assetName = assetName.replace(/\s+/g, '-');
    let folderName = assetName.split('.').slice(0, -1).join('.');
    let path = this.file.documentsDirectory+'assets/';
    
    return this.file.removeRecursively(path, folderName);
  }

  removeFile(fileName: string, fileType: string) {
    let dirURL = this.file.documentsDirectory+''+fileType+'/';
    fileName = fileName.replace(/\s+/g, '-'); // replace space with dash
    return this.file.removeFile(dirURL, fileName);
  }

  saveFile(fileData: any, asset: Asset, fileType: string) {
    let docDir = this.file.documentsDirectory+''+fileType+'/';
    let fileName = fileType == 'assets' ? asset.AssetFile : asset.Thumbnail;
    fileName = fileName.replace(/\s+/g, '-'); // replace space with dash
    let ext = fileName.substr(fileName.lastIndexOf('.') + 1);
    
    return this.writeFile(docDir, fileName, fileData, ext);

    /*this.file.checkDir(this.file.documentsDirectory, fileType)
    .then(_ => {
        let docDir = this.file.documentsDirectory+''+fileType+'/';
        let fileName = fileType == 'assets' ? asset.AssetFile : asset.Thumbnail;
        fileName = fileName.replace(/\s+/g, '-'); // replace space with dash
        let ext = fileName.substr(fileName.lastIndexOf('.') + 1);
        
    })
    .catch(
      err => {console.log('Directory doesn\'t exist');
    });*/
  }

  writeFile(docDir: string, fileName: string, fileData: any, ext: string){
    return new Promise((resolve, reject) => {
      this.file.writeFile(docDir, fileName, fileData, { replace: true})
      .then(fileEntry => {
        this.file.checkFile(docDir, fileName)
        .then(file => {
            resolve('file save success');

            if(ext.toLowerCase() == 'zip'){
              this.unZipFileInFolder(fileName, docDir);
            }
            
            console.log("dir entry :"+ docDir);
            console.log("file exist :"+ fileName);
          }
        )
        .catch(error => {
          console.log("file doesn't exist");
          reject("Writefile: file doesn't exist");
        })
      })
      .catch(error => {
        console.log("error writeFile")
        reject("Writefile: error writeFile");
      });
    });
  }

  readFile(fileName: string, fileType: string): Promise<boolean> {
    //fileType : assets or localfiles
    const dirAssetPath = this.file.documentsDirectory+fileType+'/';
    fileName = fileName.replace(/\s+/g, '-'); // replace space with dash
    return this.file.checkFile(dirAssetPath, fileName);
  }

  getFileAssetUrl(assetName: string, assetType: string){
    return new Promise((resolve, reject) => {
      let folderName = assetName.split('.').slice(0, -1).join('.');
      let assetPaths:AssetFile = {
        AssetPath: "",
        AssetHTMLPath: ""
      };
      if(this.isIosPlatform){
        assetName = assetName.replace(/\s+/g, '-'); // replace space with dash
        assetPaths.AssetPath = this.file.documentsDirectory+'assets/'+assetName
        assetPaths.AssetHTMLPath = this.file.documentsDirectory+'assets/'+assetName
      } else {
        assetPaths.AssetPath = this.assetWebURL+assetName
        assetPaths.AssetHTMLPath = this.assetWebURL+assetName
      }

      if(assetType == 'HTML' && this.isIosPlatform) {
        this.getHtmlAssetPath(folderName).then((filePath: string) => {
          assetPaths.AssetHTMLPath = filePath;
          resolve(assetPaths);
        })
        .catch(error => {
          console.log("error getHtmlAssetPath");
          reject("error getHtmlAssetPath");
        });
      } else {
        resolve(assetPaths);
      }
    });
  }

  getHtmlAssetPath(folderName: string){
    return new Promise((resolve, reject) => {
      let folderPath = this.file.documentsDirectory+'assets/';
      let assetPath = "";
      this.file.listDir(folderPath, folderName)
      .then(entry => {
        if(entry && entry.length > 0){
          let e = entry.filter(entry => entry.isFile && this.checkIsHTMLFile(entry.name));
          if(e.length > 0){
            assetPath = e[0].nativeURL;
            resolve(assetPath);
          }
          else {
            reject("No HTML file");
          }
        } else {
          reject("Empty directory");
        }
      
      })
      .catch(error => {
        console.log("REJECT LIST DIR ", error);
        reject(error);
      })
    });
  }

  getThumbAssetUrl(fileName: string){
    let fileUrl = "";
    if(this.isIosPlatform){
      fileName = fileName.replace(/\s+/g, '-'); // replace space with dash
      fileUrl = this.win.Ionic.WebView.convertFileSrc(this.file.documentsDirectory+'thumbnails/'+fileName);
    } else {
      fileUrl = this.thumbWebURL+fileName;
    }
    return fileUrl;
  }

  getFileMimeType(fileUrl: string){
    return new Promise((resolve, reject) => {
      this.file.resolveLocalFilesystemUrl(fileUrl).then((fileEntry:FileEntry) => {
        fileEntry.file(meta => {
          resolve(meta.type);
        }, error => reject("error fileEntry: getFileMimeType"));
      }).catch(error => reject("Error: file not found"));
    });
  }

  isAllowedFileSize(fileUrl: string){
    return new Promise((resolve, reject) => {
      this.file.resolveLocalFilesystemUrl(fileUrl).then(fileEntry => {
        fileEntry.getMetadata((metadata) => {
          let fileSize = metadata.size;
          let convertInMb = Math.round(fileSize / 1048576);
          if(convertInMb < this.maxFileSize){
            resolve(true);
          } else {
            resolve(false);
          }
        }, error => reject("error getMetadata" + error));
      }).catch(err => {
        reject("Error: file not found");
      });
    });
  }

  getFileSize(fileUrl: string){
    return new Promise((resolve, reject) => {
      this.file.resolveLocalFilesystemUrl(fileUrl).then(fileEntry => {
        fileEntry.getMetadata((metadata) => {
          let fileSize = metadata.size;
          //console.log("FILE SIZE : "+ fileSize);
          //let convertInMb = Math.round(fileSize / 1048576);
          //console.log("convertInMb : "+ convertInMb);
          resolve(fileSize);
        }, error => reject("error getMetadata" + error));
      }).catch(err => {
        reject("Error: file not found");
      });
    });
  }

  getPathToLocalFiles(assetName: string){
    return new Promise((resolve, reject) => {
      let fileType = "localfiles";
      let fName = assetName.replace(/\s+/g, '-');
          fName = fName.split('.').slice(0, -1).join('.');
          fName = fName.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      let path = fileType+'/'+fName;
      let file = {
        fileName: fName,
        filePath: path
      };

      this.checkDirectory(fileType)
        .then(_ => {
          console.log('Directory exists');
          resolve(file);
        })
        .catch(err => {
          console.log("createDirectory: " + fileType);
          this.createDirectory(fileType)
          .then(directoryEntry => {
              console.log('Success create new directory');
              console.log('directoryFullPath :' + directoryEntry.fullPath);
              resolve(file);
          })
          .catch(
            err => {
              console.log('Error create new directory');
              reject('Error create new directory');
            }
          )
        });
    });
  }

  getLocalFileUrl(fileName: string) {
    return this.file.documentsDirectory+'localfiles/'+fileName;
  }

  checkIsHTMLFile(entryName){
    let bool = false;
    let ext = entryName.substr(entryName.lastIndexOf('.') + 1);
    if(ext.toLowerCase() == 'html'){
      bool = true;
    }
    return bool;
  }

  unZipFileInFolder(fileName:string, docDir: string){
    console.log("create new directory zip");
    console.log("unzip into this directory");
    let folderName = fileName.split('.').slice(0, -1).join('.');
    let filePath = docDir+fileName;
    this.file.createDir(docDir, folderName, false)
    .then(directoryEntry => {
      this.unZipFile(filePath, directoryEntry.nativeURL);
    })
    .catch(error => console.log("error create directory for zip"))
  }

  unZipFile(fileUrl: string, destPath: string){
    this.zip.unzip(fileUrl, destPath, (progress) => console.log('Unzipping, ' + Math.round((progress.loaded / progress.total) * 100) + '%'))
    .then((result) => {
      if(result === 0) console.log('SUCCESS UNZIP');
      if(result === -1) console.log('FAILED UNZIP');
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/file/file.ts